import Vue from 'vue'

export default {
  state: {
    // actions is an ordered list of actions
    cluster_type: null,
    subscribables: {},
    count: null,
    type_format: 'W',
  },
  mutations: {
    UPDATE_CLUSTER_TYPE (state, value) {
      state.cluster_type = value
    },
    DELETE_SUBSCRIBABLES (state) {
      state.subscribables = {}
    },
    ADD_SUBSCRIBABLE (state, { subscribable }) {
      Vue.set(state.subscribables, subscribable.id, {
        id: subscribable.id,
        name: subscribable.name,
        description: null,
        startdate: null,
        deadline: null,
        capacity: null,
        groupIds: null,
      })
    },
    UPDATE_SUBSCRIBABLE (state, { subscribableId, name, value }) {
      state.subscribables[subscribableId][name] = value
    },
    UPDATE_COUNT (state, count) {
      state.count = count
    },
    UPDATE_TYPE_FORMAT (state, typeFormat) {
      state.type_format = typeFormat
    },
  },
  actions: {
    update_cluster_type ({ commit, state }, { cluster_type }) {
      return commit('UPDATE_CLUSTER_TYPE', cluster_type)
    },
    get_subscribables_event_series ({ commit, state }, { course_information }) {
      return axios.post('/admin/eventserie-subscribables/serie-preview', {
        type: state.cluster_type,
        course_information: course_information,
        count: state.count,
        type_format: state.type_format,
      })
    },
    update_count ({ commit, state }, count) {
      return commit('UPDATE_COUNT', count)
    },
    update_type_format ({ commit, state }, typeFormat) {
      return commit('UPDATE_TYPE_FORMAT', typeFormat)
    },
    add_subscribables ({ commit, state }, { subscribableInformation }) {
      return subscribableInformation.forEach(subscribable => {
        commit('ADD_SUBSCRIBABLE', { subscribable: subscribable })
      })
    },
    delete_subscribables ({ commit, state }) {
      return commit('DELETE_SUBSCRIBABLES')
    },
    update_subscribable ({ commit, state }, { subscribableIds, name, value }) {
      return subscribableIds.forEach((subscribableId, index) => {
        let setValue = value
        if (name === 'name' && index > 0) {
          setValue = value + ' ' + String(index + 1)
        }
        commit('UPDATE_SUBSCRIBABLE', { subscribableId: subscribableId, name: name, value: setValue })
      })
    },
  },
  getters: {},
}
